/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { IssuerMappingResponse } from '../models/issuer-mapping-response';
import { MappingFilter } from '../models/mapping-filter';
import { AsReportedIssuer } from '../models/as-reported-issuer';
import { IssuerToMap } from '../models/issuer-to-map';
import { Issuer } from '../models/issuer';
@Injectable({
  providedIn: 'root',
})
class IssuerMappingService extends __BaseService {
  static readonly getIssuerMappingPath = '/issuerMapping';
  static readonly getIssuerMappingDetailsPath = '/issuerMapping/details/{issuerId}';
  static readonly doMapTheIssuerPath = '/mapIssuer';
  static readonly updateIssuerPath = '/mapIssuer/update';
  static readonly removeIssuerPath = '/mapIssuer/removeIssuer';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param mappingFilter undefined
   * @return list of issuer mappings
   */
  getIssuerMappingResponse(mappingFilter: MappingFilter): __Observable<__StrictHttpResponse<IssuerMappingResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/issuerMapping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<IssuerMappingResponse>;
      })
    );
  }
  /**
   * @param mappingFilter undefined
   * @return list of issuer mappings
   */
  getIssuerMapping(mappingFilter: MappingFilter): __Observable<IssuerMappingResponse> {
    return this.getIssuerMappingResponse(mappingFilter).pipe(
      __map(_r => _r.body as IssuerMappingResponse)
    );
  }

  /**
   * @param issuerId undefined
   * @return array of items which are asReportedIssuer
   */
  getIssuerMappingDetailsResponse(issuerId: number): __Observable<__StrictHttpResponse<Array<AsReportedIssuer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/issuerMapping/details/${encodeURIComponent(String(issuerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AsReportedIssuer>>;
      })
    );
  }
  /**
   * @param issuerId undefined
   * @return array of items which are asReportedIssuer
   */
  getIssuerMappingDetails(issuerId: number): __Observable<Array<AsReportedIssuer>> {
    return this.getIssuerMappingDetailsResponse(issuerId).pipe(
      __map(_r => _r.body as Array<AsReportedIssuer>)
    );
  }

  /**
   * @param issuer undefined
   * @return it will be return boolean that whether issuer was mapped or not.
   */
  doMapTheIssuerResponse(issuer: IssuerToMap): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = issuer;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapIssuer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param issuer undefined
   * @return it will be return boolean that whether issuer was mapped or not.
   */
  doMapTheIssuer(issuer: IssuerToMap): __Observable<boolean> {
    return this.doMapTheIssuerResponse(issuer).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param issuerToUpdate undefined
   * @return it will return a updated issuer
   */
  updateIssuerResponse(issuerToUpdate: Issuer): __Observable<__StrictHttpResponse<Issuer>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = issuerToUpdate;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapIssuer/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Issuer>;
      })
    );
  }
  /**
   * @param issuerToUpdate undefined
   * @return it will return a updated issuer
   */
  updateIssuer(issuerToUpdate: Issuer): __Observable<Issuer> {
    return this.updateIssuerResponse(issuerToUpdate).pipe(
      __map(_r => _r.body as Issuer)
    );
  }

  /**
   * @param params The `IssuerMappingService.RemoveIssuerParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `issuerId`:
   *
   * @return it will return a boolean that whether Issuer was deleted or not.
   */
  removeIssuerResponse(params: IssuerMappingService.RemoveIssuerParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    if (params.issuerId != null) __params = __params.set('issuerId', params.issuerId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/mapIssuer/removeIssuer`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `IssuerMappingService.RemoveIssuerParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `issuerId`:
   *
   * @return it will return a boolean that whether Issuer was deleted or not.
   */
  removeIssuer(params: IssuerMappingService.RemoveIssuerParams): __Observable<boolean> {
    return this.removeIssuerResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module IssuerMappingService {

  /**
   * Parameters for removeIssuer
   */
  export interface RemoveIssuerParams {
    reason: string;
    issuerId: number;
  }
}

export { IssuerMappingService }
